/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsDeleteAnthropicInferenceConfig } from "../funcs/aiIntegrationsDeleteAnthropicInferenceConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAnthropicInferenceConfigRequest,
  DeleteAnthropicInferenceConfigSecurity,
} from "../models/operations/deleteanthropicinferenceconfig.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteAnthropicInferenceConfigMutationVariables = {
  request?: DeleteAnthropicInferenceConfigRequest | undefined;
  security?: DeleteAnthropicInferenceConfigSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteAnthropicInferenceConfigMutationData = void;

export type DeleteAnthropicInferenceConfigMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteAnthropicInferenceConfig aiIntegrations
 *
 * @remarks
 * Disconnect the organization Anthropic inference hook and revoke its URL.
 */
export function useDeleteAnthropicInferenceConfigMutation(
  options?: MutationHookOptions<
    DeleteAnthropicInferenceConfigMutationData,
    DeleteAnthropicInferenceConfigMutationError,
    DeleteAnthropicInferenceConfigMutationVariables
  >,
): UseMutationResult<
  DeleteAnthropicInferenceConfigMutationData,
  DeleteAnthropicInferenceConfigMutationError,
  DeleteAnthropicInferenceConfigMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteAnthropicInferenceConfigMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteAnthropicInferenceConfig(): MutationKey {
  return ["@gram/client", "aiIntegrations", "deleteAnthropicInferenceConfig"];
}

export function buildDeleteAnthropicInferenceConfigMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteAnthropicInferenceConfigMutationVariables,
  ) => Promise<DeleteAnthropicInferenceConfigMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteAnthropicInferenceConfig(),
    mutationFn: function deleteAnthropicInferenceConfigMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteAnthropicInferenceConfigMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(aiIntegrationsDeleteAnthropicInferenceConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
